import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import { PATH_COMMISSIONS_TIERS } from '@/lib/constants/api'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import buildInitialState from '@/store/helpers/buildInitialState'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const commissionsTiers = {
  namespaced: true,
  state: buildInitialState({
    commissionsTiersList: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    setCommissionsTiers: (state, commissions) => {
      state.commissionsTiersList = commissions
    }
  },
  actions: {
    updateCommissionsTiers: ({ commit }, commissions = []) => {
      commit('setCommissionsTiers', commissions)
    },
    clearCommissionsTiers ({ commit, dispatch }, filters = {}) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Clearing commissions tiers, please wait...' })

      return api.doDelete({ path: PATH_COMMISSIONS_TIERS, parameters: filters })
        .then(data => {
          commit('updateStatus', { status: COMPLETE })
          commit('setCommissionsTiers', [])
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to delete commissions')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getCommissionsTiers: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting commissions tiers, please wait...' })

      return api.doGet({ path: PATH_COMMISSIONS_TIERS, parameters: filters })
        .then(json => json.data)
        .then(commissions => {
          commit('updateStatus', { status: COMPLETE })
          commit('setCommissionsTiers', commissions)
          return commissions
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to select commissions')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    save ({ state }) {
      return api.doPost({ path: PATH_COMMISSIONS_TIERS, data: state.commissionsTiersList })
    },
    saveCommissionsTiers: ({ commit, dispatch, rootGetters }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving commissions tiers. Please wait...' })

      return dispatch('save')
        .then(json => json.data)
        .then(commissionsTiers => {
          commit('updateStatus', { status: COMPLETE })
          commit('setCommissionsTiers', commissionsTiers)
          notifySuccess(dispatch, 'Commissions Tiers Saved')
          return commissionsTiers
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to save commissions tiers. Try again later')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default commissionsTiers
